import React from 'react'
import '../Contact/Contact.css'
import Navbar from '../../Componect/Navbar/Navbar'
import FooterBottom from '../../Componect/Footer/FooterBottom'
function Contact() {
return (
    <>
    <div className='Contact'>
            <Navbar></Navbar>
            <div className='ContactTxt'>
                    <h1>Contact Us</h1>
                    <p>We’d love to hear from you! If you have any questions, feedback, or inquiries, feel free to reach out.</p>
                    <ul>
                            <li><strong>Our Location:</strong> Sector-17, Block-I, Road-10, Plot-26, Uttara, Dhaka</li>
                            <li><strong>Phone:</strong> 📞 01780-126370</li>
                            <li><strong>Email:</strong> 📧 stesotero53@gmail.com</li>
                            <li><strong>Operating Hours:</strong> 🕒 Monday to Sunday: 11:00 AM - 11:00 PM</li>
                    </ul>
                    <p>Feel free to reach out to us, and we will get back to you as soon as possible!</p>
            </div>
            <FooterBottom></FooterBottom>
    </div>
    </>
)
}

export default Contact